/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserChangeAvatarReportPop from '../../../../../components/UserAccount/UserChangeAvatarReportPop';
import UserProfileForm from '../../../../../components/UserAccount/UserProfileForm';
import UserChangePasswordForm from '../../../../../components/UserAccount/UserChangePasswordForm';
import UserAnketaForm from '../../../../../components/UserAccount/UserAnketaForm';
import UserAuthTypeForm from '../../../../../components/UserAccount/UserAuthTypeForm';

class UpdateAccount extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/main/update-account"
            render={() => (
              <Redirect from="/" to="/main/update-account/profile" />
            )}
          />
          <Route
            path="/main/update-account/profile"
            render={() => (
              <React.Fragment>
                <UserProfileForm userId={this.props.authUserId} />
                <UserChangePasswordForm />
                <UserAuthTypeForm />
              </React.Fragment>
            )}
          />
          <Route
            path="/main/update-account/anketa"
            render={() => <UserAnketaForm userId={this.props.authUserId} />}
          />
        </Switch>
        <Switch>
          <Route
            path={`/main/update-account/profile/change-avatar`}
            component={UserChangeAvatarReportPop}
          />
          <Route
            path={`/main/update-account/anketa/change-avatar`}
            component={UserChangeAvatarReportPop}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

UpdateAccount.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  authUserId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  authUserId: `${selectUserId(state)}`
});

export default withRouter(connect(mapStateToProps)(UpdateAccount));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/UpdateAccount/UpdateAccount.js